var Signal, jsEq, magicInitialValue;

Signal = require('../signal');

magicInitialValue = {};

jsEq = function(a, b) {
  return a === b;
};

module.exports = function(eq) {
  var prev, signal;
  if (eq == null) {
    eq = jsEq;
  }
  signal = this;
  prev = magicInitialValue;
  return signal.derive(function(send) {
    return signal.subscribe(function(val) {
      if (prev === magicInitialValue) {
        send(val);
      } else if (!eq(prev, val)) {
        send(val);
      }
      return prev = val;
    });
  });
};
